export const HELP_CONTENT = {
  // ── Bookings Form ────────────────────────────────────────────────────
  bookings: {
    phoneNumber: {
      text: "Enter the customer's mobile number including country code. Used to look up previous bookings and send appointment reminders.",
    },
    SportsphoneNumber: {
      text: "Enter the player's mobile number including country code. Used to look up previous bookings and send session reminders.",
    },
    customerName: {
      text: "Customer's full name as it should appear on the booking confirmation and invoice.",
    },
    SportscustomerName: {
      text: "Player's full name as it should appear on the booking confirmation and invoice.",
    },
    email: {
      text: "Optional. Used to send booking confirmations and follow-up messages. Accepts .com and .co.in domains.",
    },
    originBookingId: {
      text: "If this booking was created in an external system, enter its reference ID here for cross-system tracking.",
    },
    address: {
      variant: "popover",
      title: "Service Address",
      text: "Type to search and auto-complete the address using Google Maps. The service will be performed at this location.",
    },
    Sportsaddress: {
      variant: "popover",
      title: "Player Address",
      text: "Type to search and auto-complete the address using Google Maps. The session will be held at this location.",
    },
    houseNo: {
      text: "Apartment, villa, or building number. Required for the crew to locate the exact service address.",
    },
    Sportshouseno: {
      text: "Apartment, villa, or building number. Required for the coach to locate the exact session address.",
    },
    area: {
      text: "Neighbourhood or district within the city. Helps with crew routing and zone-based scheduling.",
    },
    Sportsarea: {
      text: "Neighbourhood or district within the city. Helps with coach routing and zone-based scheduling.",
    },
    landmark: {
      text: "Optional. A nearby recognisable point (e.g. 'Next to City Mall') that helps the crew find the location faster.",
    },
    Sportslandmark: {
      text: "Optional. A nearby recognisable point (e.g. 'Next to City Mall') that helps the coach find the location faster.",
    },
    state: {
      text: "Select the Emirate (UAE) or State (India) for the service address. Determines tax and zone rules.",
    },
    country: {
      text: "Country where the service will be performed. Determines currency, phone format, and tax rates.",
    },
    Sportscountry: {
      text: "Country where the session will be held. Determines currency, phone format, and tax rates.",
    },
    latLng: {
      variant: "popover",
      title: "GPS Coordinates",
      text: "Optional. Auto-filled when you select an address via Google Maps. Enter manually only if auto-fill fails. Format: Lat 25.2048, Lng 55.2708.",
    },
    profile: {
      variant: "popover",
      title: "Business Profile",
      text: "Select the branch or partner profile managing this booking. Determines which crew pool, services, and pricing apply.",
    },
    Sportsprofile: {
      variant: "popover",
      title: "Business Profile",
      text: "Select the branch or partner profile managing this booking. Determines which coach pool, sports, and pricing apply.",
    },
    status: {
      text: "'Confirmed' triggers crew assignment. 'Completed' locks the booking for invoicing.",
    },
    Sportsstatus: {
      text: "'Confirmed' triggers coach assignment. 'Completed' locks the booking for invoicing.",
    },
    paymentStatus: {
      text: "Whether the customer has paid. Set to 'Paid' after receiving payment to keep revenue reports accurate.",
    },
    DoctorpaymentStatus: {
      text: "Whether the Patient  has paid. Set to 'Paid' after receiving payment to keep revenue reports accurate.",
    },
    SportspaymentStatus: {
      text: "Whether the player has paid. Set to 'Paid' after receiving payment to keep revenue reports accurate.",
    },
    serviceOfferings: {
      variant: "popover",
      title: "Service Offerings",
      text: "Select all services included in this booking. Each item adds to the total price. Add custom services below for non-standard work.",
    },
    SportsserviceOfferings: {
      variant: "popover",
      title: "Sports Offerings",
      text: "Select all sports/activities included in this booking. Each item adds to the total price. Add custom offerings below for non-standard sessions.",
    },
    discount: {
      text: "Enter a fixed amount to subtract from the subtotal. Discounts are applied before tax is calculated.",
    },
    notes: {
      text: "Internal instructions for the crew — access codes, pet warnings, customer preferences, special equipment needed.",
    },
    Sportsnotes: {
      text: "Internal instructions for the coach — access codes, equipment needs, player preferences, special requirements.",
    },
  },

  // ── Dashboard ─────────────────────────────────────────────────────────
  dashboard: {
    datePicker: {
      text: "Jump to any date to view scheduled appointments. Defaults to today.",
    },
    providerFilter: {
      text: "Filter the calendar to show only selected crew members. Leave empty to see all crew.",
    },
  },

  // ── Analytics ─────────────────────────────────────────────────────────
  analytics: {
    periodToday: {
      text: "View bookings and revenue for a specific day. Defaults to today.",
    },
     DoctorperiodToday: {
      text: "View Appointments and revenue for a specific day. Defaults to today.",
    },
    periodWeek: {
      text: "Aggregate metrics for a 7-day period. Use the dropdown to compare previous weeks.",
    },
    periodMonth: {
      text: "Monthly totals. Use the dropdown to view up to 6 months of history.",
    },
    periodCustom: {
      text: "Select any date range to analyse a specific period — useful for campaign analysis or stakeholder reporting.",
    },
    completionRate: {
      variant: "popover",
      title: "Completion Rate",
      text: "Percentage of bookings completed vs. total confirmed. Target above 90%. Low rates may indicate scheduling or crew availability issues.",
    },
    cancellationRate: {
      variant: "popover",
      title: "Cancellation Rate",
      text: "Percentage of confirmed bookings that were cancelled. High rates may signal customer satisfaction or scheduling problems.",
    },
    noShowRate: {
      variant: "popover",
      title: "No-Show Rate",
      text: "Bookings where the crew arrived but the customer was unavailable. Each no-show represents lost revenue and wasted crew time.",
    },
    revenuePerBooking: {
      text: "Average revenue earned per completed booking. Increasing this KPI improves profitability without needing more bookings.",
    },
    revenuePerCrew: {
      text: "Average revenue generated per active crew member for the selected period. A key measure of team efficiency.",
    },
    avgJobsPerDay: {
      text: "Average number of jobs completed per day over the selected period. Useful for spotting demand fluctuations.",
    },
  },

  // ── Providers Filter Bar ──────────────────────────────────────────────
  providers: {
    search: {
      text: "Search by crew member name. Matches partial names.",
    },
    Doctorsearch: {
      text: "Search by Doctor  name. Matches partial names.",
    },
    Carsearch: {
      text: "Search by Service Provider  name. Matches partial names.",
    },
    Sportssearch: {
      text: "Search by Coach name. Matches partial names.",
    },
    serviceFilter: {
      text: "Filter the list to show only crew offering the selected services.",
    },
    DoctorFilter: {
      text: "Filter the list to show only Doctor offering the selected Specialization.",
    },
    CarFilter: {
      text: "Filter the list to show only Service Provider offering the selected services.",
    },
    SportsFilter: {
      text: "Filter the list to show only Coaches offering the selected sports.",
    },
    availability: {
      text: "Find crew available on a specific date. Members already scheduled that day will be excluded.",
    },
    gender: {
      text: "Filter by crew gender. Useful when customers have a preference.",
    },
  },

  // ── Subscription Stats ────────────────────────────────────────────────
  subscription: {
    totalPlans: {
      text: "Total number of subscription plans you have created, regardless of status.",
    },
    activePlans: {
      text: "Plans currently active and available for customers to subscribe to.",
    },
    expiringPlans: {
      text: "Plans expiring within the next 15 days. Review these to decide whether to renew or deactivate.",
    },
    inactivePlans: {
      text: "Plans that have been deactivated. Inactive plans cannot be purchased by new customers.",
    },
    expiredPlans: {
      text: "Active plans whose end date has already passed. These plans are still technically active in the system but are no longer valid. Review and deactivate them to keep your plan list clean.",
    },
  },

  // ── Purchase Slider (Subscription) ───────────────────────────────────
  purchaseSlider: {
    phoneNumber: {
      text: "Enter the subscriber's phone number. We'll auto-fill their name and address from previous bookings.",
    },
    customerName: {
      text: "Subscriber's full name as it will appear on the subscription agreement and invoices.",
    },
    email: {
      text: "Optional. Used to send subscription confirmations, renewal reminders, and upcoming visit notifications.",
    },
    scheduleType: {
      variant: "popover",
      title: "Fixed vs. Flexi Schedule",
      text: "Fixed: visits occur on the same day(s) every cycle at a set time. Flexi: the customer calls to book each visit within the plan period — no locked schedule.",
    },
    frequency: {
      variant: "popover",
      title: "Visit Frequency",
      text: "How often the service recurs within the plan. Weekly = every 7 days, Monthly = every 30 days, Quarterly = every 3 months, Half Yearly = every 6 months.",
    },
    startDate: {
      text: "The date the subscription begins. The first visit will be scheduled from this date based on the selected frequency.",
    },
    preferredTime: {
      text: "Customer's preferred visit time. The crew will be assigned to available slots closest to this time.",
    },
    daysOfWeek: {
      text: "For weekly plans, select the day(s) the crew should visit. Multiple days can be selected if the plan includes more than one visit per week.",
    },
    crewAssignment: {
      text: "Optionally assign a specific crew member for all visits in this plan. Leave empty to auto-assign based on availability.",
    },
    address: {
      variant: "popover",
      title: "Service Address",
      text: "The location where all visits will be performed. Type to search via Google Maps — area and state fields fill automatically.",
    },
    houseNo: {
      text: "Apartment, villa, or building number. Required for the crew to find the exact service location.",
    },
    area: {
      text: "Neighbourhood or district. Used for crew routing and zone-based scheduling.",
    },
    state: {
      text: "Select the Emirate (UAE) or State (India) matching the service address.",
    },
    country: {
      text: "Country of the service address. Determines currency and applicable tax rules.",
    },
  },

  // ── Edit Provider Sidebar ─────────────────────────────────────────────
  editProvider: {
      about: {
      text: "A short professional bio visible to customers. Highlight specialisations, certifications, or anything that builds trust.",
    },
    Doctorabout: {
      text: "A short professional bio visible to Patients. Highlight specialisations, certifications, or anything that builds trust.",
    },
    SportsProviderabout: {
      text: "A short professional bio visible to Players. Highlight specialisations, certifications, or anything that builds trust.",
    },
    payroll:{
      text: "A short professional bio visible to customers. Highlight specialisations, certifications, or anything that builds trust.",
    },
    

  // Crew (Default)
  name: {
    text: "Full name of the crew member as it appears to customers in booking confirmations.",
  },

  // Clinic
  Doctorname: {
    text: "Full name of the Doctor as it appears to Patients in booking confirmations.",
  },

  // Car Service
  ServiceProviderName: {
    text: "Full name of the service provider as it appears to customers in booking confirmations and service requests.",
  },

  // Sports
  SportsProviderName: {
    text: "Full name of the coach, trainer, or sports professional as it appears to players during booking and scheduling.",
  },

  // ---------------- Gender ----------------

  gender: {
    text: "Crew member's gender. Customers can filter providers by gender preference.",
  },

  Doctorgender: {
    text: "Doctor's gender. Patients can filter providers by gender preference.",
  },

  ServiceProvidergender: {
    text: "Gender of the service provider. Used only for profile information where applicable.",
  },

  SportsProvidergender: {
    text: "Gender of the coach or sports professional. Used only for profile information where applicable.",
  },

  // ---------------- Experience ----------------

  experienceStart: {
    // variant: "popover",
    title: "Experience Start Date",
    text: "The date this crew member began professional practice. Used to calculate years of experience shown on their profile card.",
  },

  DoctorexperienceStart: {
    // variant: "popover",
    title: "Experience Start Date",
    text: "The date this Doctor began professional practice. Used to calculate years of experience shown on their profile card.",
  },

  ServiceProviderexperienceStart: {
    // variant: "popover",
    title: "Experience Start Date",
    text: "The date this service provider started working professionally. Used to display total years of experience.",
  },

  SportsProviderexperienceStart: {
    // variant: "popover",
    title: "Experience Start Date",
    text: "The date this coach or sports professional started their professional career. Used to display total experience.",
  },

  // ---------------- Services ----------------

  services: {
    // variant: "popover",
    title: "Assigned Services",
    text: "Services this crew member is qualified to perform. Only bookings for these services will appear in their scheduling calendar.",
  },

  Doctorservices: {
    // variant: "popover",
    title: "Assigned Specialization",
    text: "Specializations this Doctor is qualified to provide. Only appointments for these specializations will appear in their schedule.",
  },

  ServiceProviderservices: {
    // variant: "popover",
    title: "Assigned Services",
    text: "Select the services this service provider is qualified to perform. Only those services can be assigned to them.",
  },

  SportsProviderservices: {
    // variant: "popover",
    title: "Assigned Sports",
    text: "Select the sports or activities this coach or trainer is qualified to teach or manage.",
  },

  // ---------------- Unique ID ----------------

  uniqueId: {
    text: "A unique identifier for this crew member — e.g. employee ID or licence number. Used for internal records.",
  },

  DoctoruniqueId: {
    text: "A unique identifier for this Doctor — e.g. medical licence number or employee ID. Used for internal records.",
  },

  ServiceProvideruniqueId: {
    text: "A unique identifier for this service provider such as employee ID or staff code.",
  },

  SportsProvideruniqueId: {
    text: "A unique identifier for this coach or trainer such as employee ID or registration number.",
  },

  // ---------------- Phone ----------------

  phone: {
    text: "Crew member's registered phone number. Locked after account creation.",
  },

  Doctorphone: {
    text: "Doctor's registered phone number. Locked after account creation.",
  },

  ServiceProviderphone: {
    text: "Service provider's registered phone number. Locked after account creation.",
  },

  SportsProviderphone: {
    text: "Coach or trainer's registered phone number. Locked after account creation.",
  },

  // ---------------- Country ----------------

  country: {
    text: "Country of residence. Determines regional settings for this crew member's profile.",
  },

  Doctorcountry: {
    text: "Country of residence. Determines regional settings for this Doctor profile.",
  },

  ServiceProvidercountry: {
    text: "Country where this service provider is based.",
  },

  SportsProvidercountry: {
    text: "Country where this coach or sports professional is based.",
  },

  state: {
    text: "State of residence. Used for proximity-based crew assignment.",
  },

  DoctorState: {
    text: "State of residence. Used for proximity-based Doctor assignment.",
  },

  ServiceProviderState: {
    text: "State where this service provider primarily operates.",
  },

  SportsProviderState: {
    text: "State where this coach or sports professional primarily provides services.",
  },

  // ---------------- City ----------------

  city: {
    text: "City of residence. Used for proximity-based crew assignment.",
  },

  Doctorcity: {
    text: "City of residence. Used for proximity-based Doctor assignment.",
  },

  ServiceProvidercity: {
    text: "City where this service provider primarily operates.",
  },

  SportsProvidercity: {
    text: "City where this coach or sports professional primarily provides services.",
  },

  // ---------------- Email ----------------

  email: {
    text: "Crew member's email address. Used for shift notifications and internal communications.",
  },

  Doctoremail: {
    text: "Doctor's email address. Used for appointment notifications and internal communications.",
  },

  ServiceProvideremail: {
    text: "Service provider's email address. Used for notifications and internal communication.",
  },

  SportsProvideremail: {
    text: "Sports email address. Used for notifications and internal communication.",
  },
},

  // ── New Appointment Offcanvas (Dashboard) ─────────────────────────────
  newAppointment: {
    partner: {
      text: "Select the branch or partner profile managing this appointment. Determines which Specializations, doctors, and pricing apply.",
    },
    mobileNumber: {
      text: "Patient's contact number. Used to look up an existing patient record and for appointment notifications.",
    },
    gender: {
      text: "Patient's gender, used for medical records.",
    },
    service: {
      // variant: "popover",
      title: "Specialization Selection",
      text: "Select the Specialization for this appointment. Available doctors and time slots update to match the selected Specialization.",
    },
    specializationType: {
      text: "Select the specific type under the chosen Specialization. Doctors and time slots shown are scoped to the selected Specialization.",
    },
    insuranceNumber: {
      text: "Optional. The patient's insurance policy or membership number, if applicable.",
    },
    insuranceProvider: {
      text: "Optional. The patient's insurance company, used for billing and claims reference.",
    },
    provider: {
      text: "Select the doctor for this appointment. Only doctors qualified for the selected Specialization are shown.",
    },
    date: {
      text: "Select the appointment date. Available time slots update based on the doctor's schedule for that day.",
    },
    timeSlot: {
      text: "Select an available time slot. Slots in grey are already booked.",
    },
    patientName: {
      text: "Patient's full name. Used in the appointment confirmation and doctor briefing.",
    },
    notes: {
      text: "Special instructions for the doctor — specific requirements or patient preferences.",
    },
    status: {
      text: "'Confirmed' triggers doctor assignment. 'Completed' locks the booking for invoicing.",
    },
  },

  // ── Create / Edit Subscription Plan Modal ────────────────────────────
  createSubscription: {
    planName: {
      text: "A clear, customer-facing name for this plan (e.g. 'Monthly Deep Clean'). Keep it short and descriptive.",
    },
    serviceOffering: {
      text: "The specific service offering this plan covers. Subscribers receive this service on each visit.",
    },
    subscriptionType: {
      variant: "popover",
      title: "Subscription Type",
      text: "Open: customers book visits flexibly within the plan period. Fixed: visits are pre-scheduled on a recurring cycle (weekly, monthly, etc.).",
    },
    pricing: {
      variant: "popover",
      title: "Plan Pricing",
      text: "The total amount charged when a customer pays for this plan in full at purchase. For Fixed plans, you can instead charge a Monthly Recurring amount below.",
    },
    paymentType: {
      variant: "popover",
      title: "Payment Type",
      text: "Full Payment: the customer pays the whole plan price once at purchase. Monthly Recurring: the customer pays a fixed amount every month to keep the plan active, regardless of visit frequency (available for Fixed plans).",
    },
    recurringAmount: {
      text: "The amount charged each month to keep this subscription active. For Weekly plans, the customer's first payment may be pro-rated based on how many classes remain in the month they join; other frequencies charge the full amount at purchase.",
    },
    recurringDueDay: {
      text: "The day of the month recurring payments are due (e.g. the 5th of every month). This applies to all subscribers on this plan.",
    },
    duration: {
      text: "How long the plan is valid — e.g. 1 month, 3 months. After expiry the plan must be renewed.",
    },
    description: {
      text: "Optional description shown to customers. Explain what is included, how many visits, and any terms.",
    },
  },

  // ── Add Service / Add Profile (AdminSetup page) ──────────────────────
  addService: {
    serviceName: {
      text: "A unique name for this service category (e.g. 'Deep Cleaning', 'Pest Control'). This is the top-level name visible to customers when booking.",
    },
    isSubCategory: {
      placement: "bottom",
      text: "Enable this if you are adding a sub-category under an existing service rather than a new top-level service. Sub-categories group related offerings under one parent service.",
    },
    description: {
      text: "Optional. A brief summary of what this service involves. Shown to customers on the service listing and booking confirmation.",
    },
  },

  addProfile: {
    profileName: {
      variant: "popover",
      title: "Profile Name",
      text: "Name of the business branch or partner profile (e.g. 'Dubai Marina Branch'). Each profile manages its own crew pool, services, and pricing independently.",
    },
    commission: {
      text: "Optional. Commission percentage charged to this profile on each completed booking. Leave empty if a flat rate or no commission applies.",
    },
  },
};
